import { Component, Input } from "@angular/core";

@Component({
    selector: 'avatars-group',
    styles: [`
      .tipsy {
          text-align: left;
          white-space: pre-wrap;
      }
      .more-users {
          background: #dddbdb;
          color: black;
          border-radius: 50%;
          padding: 2px;
      }
  `],
    template: `
    <div class="avatar-group">

      <div class="avatar-group-item" *ngFor="let user of filteredUsers">
        <a href="javascript: void(0);" class="d-inline-block" container="body" placement="top"
           [ngbTooltip]="user.name +' | '+ user.email">
          <img default-avatar [src]="user.imageUrl" alt="User Image" class="rounded-circle avatar-xxs">
        </a>
      </div>

      <div class="avatar-group-item" *ngIf="remaining > 0">
        <a href="javascript: void(0);" class="d-inline-block" container="body" placement="top"
           [ngbTooltip]="remaining + ' more'">
          <span class="more-users">+{{remaining}}</span>
        </a>
      </div>

    </div>

    <!--    <ng-template #userTooltip>-->
    <!--      <div class="d-flex flex-column">-->
    <!--        <span>{{ content.name}}</span>-->
    <!--        <span>{{ content.email}}</span>-->
    <!--      </div>-->
    <!--    </ng-template>-->
  `,
    standalone: false
})
export class AvatarsGroupComponent {

  @Input('users') users: IUserInfo[] = [];
  @Input('maxUsersToDisplay') maxUsersToDisplay: number = 10;

  get remaining(): number {
    return this.users?.length - this.maxUsersToDisplay;
  }

  get filteredUsers(): IUserInfo[] {
    return this.users.slice(0, this.maxUsersToDisplay);
  }

}

export interface IUserInfo {
  name: string;
  email: string;
  imageUrl: string;
}
